<template>
  <div class="wrapper">
    <el-empty description="敬请期待"></el-empty>
  </div>
</template>

<script>
export default {
  name: 'Home',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
.wrapper{
  width: 100%;
}
</style>